import React, { forwardRef } from 'react'
import styles from './NextButton.module.css'
import { NextButtonProps } from './types'
import { useStepContext } from '@/components/Context/StepContext'

export const NextButton = forwardRef<HTMLDivElement, NextButtonProps>(({
    disabled = false,
    dataClickLabel,
    onClick
}, ref) => {
    const { handleNext } = useStepContext()

    const handleClick = () => {
        if (onClick) {
            onClick()
        } else {
            handleNext()
        }
    }

    return (
        <div className={styles.buttonContainer} ref={ref}>
            <button
                className={styles.nextButton}
                disabled={disabled}
                data-click-label={dataClickLabel}
                onClick={handleClick}
                type='button'
            >
                次へ
                <span className={styles.nextArrow}>＞</span>
            </button>
        </div>
    )
})
